import { FC, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { Footer } from 'components'
import { RoutesWrapper } from 'libraries/router'

import Header from '../Header'

// Disable the browser's scroll restoration so a refresh while scrolled down
// doesn't restore the old position and then snap to the top (hero flash).
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

const PageLayout: FC = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <main>
      <Header />

      <section>
        <RoutesWrapper />
      </section>

      <Footer />
    </main>
  )
}

export default PageLayout
